ANTRAGSGRUEN_STRINGS = {
    "std": {
        "del_confirm": "Weet je zeker dat je dit wilt verwijderen?",
        "draft_del": "Concept verwijderen",
        "draft_del_confirm": "Weet je zeker dat je dit wilt verwijderen?",
        "draft_date": "Conceptdatum",
        "draft_restore_confirm": "Dit concept herstellen?",
        "min_x_supporter": "Je moet minimaal %NUM% ondersteuners hebben.",
        "missing_resolution_date": "Er moet een resolutiedatum worden opgegeven.",
        "missing_gender": "Vul iets in bij het genderveld",
        "pw_x_chars": "Het wachtwoord moet minimaal %NUM% tekens lang zijn.",
        "pw_min_x_chars": "Minimaal %NUM% tekens",
        "pw_no_match": "De twee wachtwoorden komen niet overeen.",
        "leave_changed_page": "Er zijn nog niet opgeslagen wijzigingen. Weet je zeker dat je deze pagina wilt verlaten?",
        "moved_paragraph_from": "Verplaatst van alinea ##PARA##.",
        "moved_paragraph_to": "Verplaatst naar alinea ##PARA##.",
        "moved_paragraph_from_line": "Verplaatst van alinea ##PARA## (regel ##LINE##)",
        "moved_paragraph_to_line": "Verplaatst naar alinea ##PARA## (regel ##LINE##)"
    },
    "merge": {
        "initiated_by": "Aangeleverd door",
        "title_open_in_blank": "Open de wijziging in een nieuw venster",
        "title_del_title": "Verwijder \"tegenstrijdige: ...\" titel",
        "title_del_colliding": "Verwijder het volledige tegenstrijdige blok",
        "title": "Titel",
        "change_accept": "Overnemen",
        "change_reject": "Werwerpen",
        "colliding_title": "Tegenstrijdige ÄA",
        "colliding_start": "Tegenstrijdigheid start hier",
        "colliding_end": "Tegenstrijdigheid tot hier",
        "reloadParagraph": "Als deze selectie wordt gewijzigd, gaan handmatige wijzigingen in deze paragraaf verloren. Volgende?"
    },
    "admin": {
        "adminMayEditConfirm": "Als dit wordt gedeactiveerd, heeft dit ook invloed op alle eerdere toepassingen en kan dit niet worden geannuleerd voor eerdere toepassingen. Wil je doorgaan?",
        "deleteDataConfirm": "Wil je deze informatie echt verwijderen?",
        "agendaAddEntry": "Item toevoegen",
        "agendaAddDate": "Datum toevoegen",
        "agendaShowTimes": "Exacte tijden instellen",
        "agendaDelEntryConfirm": "Dit agendapunt en diens subpunten schrappen?",
        "removeAdminConfirm": "Wil je echt de beheerdersrechten van dit account intrekken?",
        "removeUserConfirm": "Echt %NAME% van DIT evenement verwijderen? Ingediende aanvragen enz. worden bewaard en moeten expliciet worden verwijderd.",
        "deleteUserConfirm": "%NAME% echt verwijderen? Ingediende aanvragen enz. worden bewaard en moeten expliciet worden verwijderd.",
        "emailMissingCode": "De e-mailtekst moet de code %ACCOUNT% bevatten.",
        "emailMissingLink": "De e-mailtekst moet de code %LINK% bevatten.",
        "emailMissingTo": "Er werden geen e-mailadressen opgegeven.",
        "emailMissingUsername": "Er werden geen usernames genoemd.",
        "emailNumberMismatch": "Er zijn niet evenveel usernames als e-mailadressen. Zorg ervoor dat er precies één naam wordt ingevuld voor elke regel met e-mailadressen!",
        "delMotionConfirm": "Weet je zeker dat je dit verzoek wilt verwijderen?",
        "delAmendmentConfirm": "Weet je zeker dat je deze wijziging wilt verwijderen?",
        "delPageConfirm": "Weet je zeker dat je deze pagina wilt verwijderen?",
        "deleteMotionSectionConfirm": "Als dit type wordt verwijderd, worden ook alle stukken van dit type verwijderd. Wil je dit echt verwijderen?",
        "consDeleteConfirm": "Moet dit evenement, inclusief alle moties en amendementen, echt worden afgelast?",
        "gotoUpdateModeConfirm": "Moet de updatemodus worden geactiveerd? De applicatie is niet beschikbaar wanneer de updatemodus actief is."
    }
};
